export const insightsAttrs = ({ category = '', label = '', value, version, funnelConversion }) => ({
  'data-insights-category': category,
  'data-insights-label': label,
  ...(value ? { 'data-insights-value': value } : {}),
  ...(version ? { 'data-insights-version': version } : {}),
  ...(funnelConversion ? { 'data-insights-funnel-conversion': funnelConversion } : {})
})
